/* eslint-disable prefer-template */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */
/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */

import { useEffect, useState } from 'react';
import './dailyStats.css';
import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import RefreshIcon from '@mui/icons-material/Refresh';
import Stack from '@mui/material/Stack';
import moment from 'moment-timezone';
import Skeleton from '@mui/material/Skeleton';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import { Chart } from 'react-charts';
import DatePicker from 'react-datepicker';
import { formatMinutesToMinutesAndSeconds } from '../../utils/formatDuration';
import Subcription from '../Subcription/Subcription';
import { useDailyStatsStore } from '../../store/dailyStatsStore';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDatePickerInput = React.forwardRef(({ value, onClick, className }, ref) => (
  <button type="button" className={`d-flex custom-date-picker-input ${className || ''}`} onClick={onClick} ref={ref}>
    {value} <span className="fa fa-chevron-down align-self-center" style={{ fontSize: '10px', paddingLeft: '6px' }} />
  </button>
));

CustomDatePickerInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
CustomDatePickerInput.displayName = 'CustomDatePickerInput';

const DailyStats = () => {
  const navigate = useNavigate();
  const { loading, summary, chartData, selectedDate, setTimeZone, loadDailyStats } = useDailyStatsStore();
  const [startDate, setStartDate] = useState(selectedDate || new Date());

  useEffect(() => {
    const getTimeZone = () => {
      const { timeZone: localTimeZone } = Intl.DateTimeFormat().resolvedOptions();
      setTimeZone(localTimeZone);
      loadDailyStats({ date: new Date() });
    };

    getTimeZone();
  }, [loadDailyStats, setTimeZone]);

  const fetchData = async () => {
    await loadDailyStats({ date: new Date(), force: true });
    setStartDate(new Date());
  };

  const fetchDataByDate = async (date) => {
    await loadDailyStats({ date, force: true });
    setStartDate(date);
  };

  const primaryAxis = React.useMemo(
    () => ({
      getValue: (datum) => datum.title,
      tickLabelStyle: {
        fontSize: 20,
      },
    }),
    []
  );

  const secondaryAxes = React.useMemo(
    () => [
      {
        getValue: (datum) => datum.value,
        min: 0,
        hardMin: 0,
      },
    ],
    []
  );

  return (
    <>
      <div className="transaction-card p-4">
        <h5 className="text-start w-100 mb-1">
          <i className="me-4" onClick={() => navigate(-1)}>
            <KeyboardBackspaceIcon color="primary" fontSize="small" />
          </i>
          Voice AI Statistics &nbsp;&nbsp;
          <Button variant="contained" color="primary" size="small" startIcon={<RefreshIcon />} onClick={fetchData}>
            Refresh
          </Button>
        </h5>

        <h5>
          <div className="me-4 d-flex justify-content-center mt-4">
            Showing stats for
            <DatePicker
              minDate={moment().subtract(5, 'days').toDate()}
              maxDate={new Date()}
              selected={startDate}
              onChange={(date) => fetchDataByDate(date)}
              dateFormat="MM/dd/yyyy"
              customInput={<CustomDatePickerInput className="example-custom-input" />}
            />
          </div>
        </h5>

        {loading ? (
          <div className="m-4">
            <div className="summary-cards">
              {[1, 2, 3, 4, 5, 6, 7].map((card) => (
                <div className="card" key={card}>
                  <div className="card-header" style={{ background: 'none', border: 'none' }}>
                    <Skeleton variant="text" width={120} height={22} />
                    <Skeleton variant="text" width={80} height={36} />
                  </div>
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-center mb-4 mt-4">
              <Skeleton variant="rounded" width={800} height={320} />
            </div>
          </div>
        ) : (
          <>
            <div className="m-4">
              {summary && summary.today && (
                <div className="summary-cards">
                  <div className="card">
                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                      <p>Voice AI Calls</p>
                      <h2 className="card-price">{summary.today.totalCalls}</h2>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                      <p>Calls Connected</p>
                      <h2 className="card-price">{summary.today.totalCallsConnected}</h2>
                      {summary.today.totalCallsConnected > 0 && (
                        <small>Percent of calls connected - {summary.today.percentCallsConnected}%</small>
                      )}
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                      <p>No Answer/Voicemail</p>
                      <h2 className="card-price">{summary.today.totalCallsNoAnswerVoicemail}</h2>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                      <p>DNC</p>
                      <h2 className="card-price">{summary.today.totalCallsDNC}</h2>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                      <p>Human Followups</p>
                      <h2 className="card-price">{summary.today.totalCallsHumanFollowup}</h2>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                      <p>Appointments Booked</p>
                      <h2 className="card-price">{summary.today.totalCallsAppointments}</h2>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                      <p>Live Transfers</p>
                      <h2 className="card-price">{summary.today.totalLiveTransfers}</h2>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex justify-content-center mb-4">
              <div style={{ height: '400px', width: '800px' }}>
                {/* horizontal bar graph */}
                {chartData && chartData.length > 0 && (
                  <Chart
                    options={{
                      data: chartData,
                      primaryAxis: primaryAxis,
                      secondaryAxes: secondaryAxes,
                      getSeriesStyle: (series) => ({
                        width: '20px',
                      }),
                    }}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default DailyStats;
